export const oldestDocumentDate = new Date(2019, 6, 1);

export const RADIO_BUTTON_PAST_OPTIONS = [
  {
    value: "past7Days",
    label: "Past 7 days",
  },
  {
    value: "past30Days",
    label: "Past 30 days",
  },
  {
    value: "past6Months",
    label: "Past 6 months",
  },
  {
    value: "pastYear",
    label: "Past year",
  },
  {
    value: "customRange",
    label: "Custom range",
  },
];

export const RADIO_BUTTON_FUTURE_OPTIONS = [
  {
    value: "pastDue",
    label: "Past due",
  },
  {
    value: "next7Days",
    label: "Next 7 days",
  },
  {
    value: "next30Days",
    label: "Next 30 days",
  },
  {
    value: "next6Months",
    label: "Next 6 months",
  },
  {
    value: "nextYear",
    label: "Next year",
  },
  {
    value: "customRange",
    label: "Custom range",
  },
];
